<script setup>
import {ref, watch} from 'vue';
import BaseInputFloatingLabelNumber from "@/components/forms/BaseInputFloatingLabelNumber.vue";

const props = defineProps({
  modelValue: [Number, String],
  label: {
    type: String,
    default: 'Stake' // Default value for label
  },
});

const emits = defineEmits(['update:modelValue']);

const localValue = ref(props.modelValue);

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue;
});
</script>

<template>
  <div>
    <BaseInputFloatingLabelNumber
        :config="{ label: label, name: 'stake', hasClearButton: false }"
        v-model="localValue"
    />
  </div>
</template>

